import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { UsersState } from "./types";

const initialState: UsersState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchUsersDataAsync = createAsyncThunk(
  "users/fetchUsersData",
  async () => await api.getUsers()
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsersDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUsersDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch users data";
      });
  },
});

export default usersSlice.reducer;
